import type { ResidualErrors } from './mileageCostOptionsTypes';
import { RESIDUAL_FIELD_LABELS } from './constants';

export type ValidationResult = {
    isValid: boolean;
    error?: string;
};

export const validateResidualBasedOn = (value: string | number | null | undefined): ValidationResult => {
    if (value == null || value === '') {
        return { isValid: true }; // Empty values are valid, field is not required
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (typeof numValue !== 'number' || isNaN(numValue)) {
        return { isValid: false, error: 'Residual based on must be a valid number' };
    }

    if (numValue < 0) {
        return { isValid: false, error: 'Residual based on must be >= 0' };
    }

    return { isValid: true };
};

export const validateProgramResidual = (
    value: string | number | null | undefined,
    fieldLabel: string = RESIDUAL_FIELD_LABELS.PROGRAM_RESIDUAL
): ValidationResult => {
    if (value == null || value === '') {
        return { isValid: true };
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (typeof numValue !== 'number' || isNaN(numValue)) {
        return { isValid: false, error: `${fieldLabel} must be a valid number` };
    }

    if (numValue < 0) {
        return { isValid: false, error: `${fieldLabel} must be >= 0` };
    }

    return { isValid: true };
};

export const validateProgramResidualPercent = (
    value: string | number | null | undefined,
    fieldLabel: string = RESIDUAL_FIELD_LABELS.PROGRAM_RESIDUAL_PERCENT
): ValidationResult => {
    if (value == null || value === '') {
        return { isValid: true };
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (typeof numValue !== 'number' || isNaN(numValue)) {
        return { isValid: false, error: `${fieldLabel} must be a valid number` };
    }

    if (numValue < 0 || numValue > 100) {
        return { isValid: false, error: `${fieldLabel} must be between 0 and 100` };
    }

    return { isValid: true };
};

export const hasResidualValidationErrors = (errors: ResidualErrors): boolean => {
    return Object.values(errors).some((error) => !!error);
};
